export const navigateRoutes = {
  signIn: '/sign-in',
  signUp: '/sign-up',
  resetPassword: '/reset-password/:id',
  forgotPassword: '/forgot-password',

  savedContacts: '/saved-contacts',
  savedUsers: '/saved-users',
  savedCompanies: '/saved-companies',
  viewContact: '/view-contact/:id',
  support: '/support',
};
